import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-new-candidate-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './new-candidate.component.html',
  imports: [
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailButtonComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class NewCandidateTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<NewCandidateTemplateData>;
}

export type NewCandidateTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
};

export const NewCandidateTemplateMocks: NewCandidateTemplateData[] = [
  {
    title: 'A new candidate has applied',
    p1: 'Candidate TP candidate applied for the job.',
    button_link: 'http://recruitee.com',
    button_text: 'View candidate',
  },
];
